import React from 'react';


export default function Intro() {

  return (
    <div className='intro-div'>
      <div className='intro-left'>
        <img src="profile_pic.png" alt='rishabh' className="rounded-image"></img>
        <p className='summary-header'>Hi<br></br>I'm Rishabh</p>
        <p className='summary-sub-header'>Product Leader | ESG Advocate | Tech Enthusiast</p>
      </div>
      <div className='intro-right'>
        <p className='summary-desc'>An accomplished product leader who has delivered and scaled up multiple software products in the last 10 years. Specialises in using customer insights and data to figure out profitable solutions that scale. Adept at driving technical discussions and user experience design while managing roadmaps and backlog prioritization using Agile methodologies. Experienced in leveraging AI and API integrations and skilled in shaping product vision and fostering strong stakeholder relationships
        </p>
      </div>
    </div>
  );


}

